<template>
  <section class="wrap light-gray">
    <div class="container-wrap">
      <div class="title observer-selector">
        많은 기업들이<br />
        디버의 Fit한 배송을<br class="only-mobile" />
        경험하고 있어요
      </div>
      <div class="content">
        <vue-marquee-slider
          id="marquee-slider-space"
          :speed="100000"
          :width="128"
          :space="20"
        >
          <img
            v-for="logo in 20"
            :key="logo"
            :src="require(`@/assets/img/main/client/package/logo_${logo}.png`)"
          />
        </vue-marquee-slider>
        <vue-marquee-slider
          id="marquee-slider-reverse"
          :speed="100000"
          :width="128"
          :space="20"
          reverse
        >
          <img
            v-for="logo in 27"
            :key="logo"
            :src="
              require(`@/assets/img/main/client/package/logo_${logo + 20}.png`)
            "
          />
        </vue-marquee-slider>
      </div>
    </div>
  </section>
</template>
<script>
import { VueMarqueeSlider } from "vue-marquee-slider";
export default {
  components: {
    VueMarqueeSlider
  }
};
</script>
<style src="../home.common.css" scoped />
<style scoped>
img {
  background-color: var(--white);
  border-radius: 18px;
  width: 128px !important;
  height: 128px !important;
}

.title {
  text-align: start;
}
.only-mobile {
  display: block;
}

.content {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

@media (min-width: 1024px) {
  .title {
    text-align: center;
  }
  .only-mobile {
    display: none;
  }

  .content {
    margin-top: 56px;
    gap: 20px;
  }
}
</style>
